export default "/assets/images/nerd-face.png?c6d9b87185cdd8af5f27462140f8ca6e";